import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mankhurdtopunecab() {



const cardData = {
  keyword: " Mankhurd to Pune Cab  ",

headingDescription: "Velocity Cab provides reliable and comfortable Mankhurd to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mankhurd to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mankhurd to Pune cab travel.",

topPlaces: [

  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a prominent heritage monument in Pune known for its connection to India's freedom movement. Visitors can admire its elegant architecture, beautifully maintained gardens, and museum dedicated to Mahatma Gandhi, making it a popular stop for history enthusiasts."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune's most visited spiritual landmarks, attracting devotees throughout the year. Travelers can seek blessings, admire the beautifully adorned idol of Lord Ganesha, and experience the vibrant atmosphere surrounding the temple."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases an impressive collection of Indian art, antiques, traditional musical instruments, sculptures, and decorative artifacts. It offers visitors a fascinating glimpse into India's rich artistic and cultural heritage."
  },
    {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is Pune’s most iconic historical fortification and a symbol of the Maratha Empire. Travelers booking a sedan cab in Pune can explore its majestic gateways, sprawling courtyards, and historic ruins while learning about the city's rich cultural heritage through the evening light and sound show."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. Its peaceful surroundings and intricate architecture make it an ideal destination for spiritual visits and photography."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is one of Pune's oldest heritage sites, offering panoramic views of the city from its hilltop temple complex. Visitors can climb the historic steps, explore ancient temples, and enjoy breathtaking views of Pune's skyline."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a beautifully designed Japanese-style garden featuring landscaped lawns, ponds, waterfalls, and walking paths. It provides a tranquil escape for nature lovers, families, and photography enthusiasts."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular public garden in Pune featuring lush greenery, walking trails, and the famous Siddhivinayak Temple. It is a favorite destination for families, morning walkers, and visitors seeking a peaceful environment."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park known for its greenery, boating activities, and relaxing atmosphere. Travelers can enjoy leisurely walks, spend time with family, and unwind amidst nature in the heart of Pune."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is one of the city's premier shopping and entertainment destinations. Visitors can explore leading fashion brands, enjoy diverse dining options, watch movies, and experience live events, making it an ideal stop for shopping and leisure."
  }
],



services: [
{
name: "Mankhurd to Pune Cab Service",
description: "Mankhurd to Pune cab service provides reliable and comfortable intercity travel from Mumbai’s eastern suburb to Pune via the Mumbai–Pune Expressway. This route is preferred by working professionals, families, and frequent travelers for its smooth connectivity and reduced travel time. Customers can choose from sedan, Ertiga, and Innova Crysta vehicles depending on comfort and group size. Pickup is available from Mankhurd residential areas, nearby railway station, and surrounding localities. Professional drivers ensure safe highway driving with timely pickup and drop. Clean, air-conditioned vehicles with ample luggage space make long-distance travel comfortable. Online booking with transparent pricing ensures a hassle-free experience for every passenger."
},
{
name: "Mankhurd to Pimpri Cab",
description: "Mankhurd to Pimpri cab service offers direct travel to Pimpri and nearby PCMC areas with convenient door-to-door pickup and drop. Travelers can enjoy comfortable rides with experienced drivers ensuring safe and smooth journeys. This service is ideal for office commuters, business travelers, and families traveling to Pimpri-Chinchwad."
},
{
name: "Mankhurd to Pune One Way Cab",
description: "Mankhurd to Pune one way cab service provides cost-effective travel for passengers requiring a single-direction trip. This option is perfect for airport transfers, office travel, or shifting between cities without return charges. Customers can choose from budget-friendly sedans or premium SUVs."
},
{
name: "Chembur to Pune Car Fare",
description: "Chembur to Pune car fare service provides transparent and competitive pricing for travelers commuting between Chembur and Pune. Fare depends on vehicle type, distance, and travel timing, with no hidden charges. This helps customers plan their journey efficiently with budget-friendly options."
},
{
name: "Belapur to Pune by Taxi",
description: "Belapur to Pune taxi service offers smooth and convenient travel from Navi Mumbai to Pune. With easy pickup from CBD Belapur residential and commercial areas, this service is widely used by professionals and families for regular travel."
},
{
name: "Belapur to Pune One Way Cab",
description: "Belapur to Pune one way cab service offers economical travel for passengers requiring one-direction transportation. It is ideal for quick trips and business travel with flexible pickup and drop options."
},
{
name: "Belapur to Pimpri Chinchwad Cab",
description: "Belapur to Pimpri Chinchwad cab service provides direct connectivity to PCMC areas including Pimpri, Chinchwad, and nearby locations. Travelers can enjoy comfortable travel with professional drivers."
},
{
name: "Belapur to Baner Cab Fare",
description: "Belapur to Baner cab fare service offers transparent pricing for travel between Navi Mumbai and Pune’s Baner area. Customers can choose from different vehicle options based on comfort and budget."
},
{
name: "Seawoods to Pune Cab Fare",
description: "Seawoods to Pune cab fare provides affordable pricing for comfortable intercity travel. Travelers can choose from sedan, Ertiga, and Innova Crysta vehicles with clear fare details."
},
{
name: "Seawoods to Pune Station Cab",
description: "Seawoods to Pune station cab service provides direct transportation to Pune railway station. This service is ideal for passengers catching trains or arriving in Pune."
},
{
name: "Sanpada to Pune Cab Service",
description: "Sanpada to Pune cab service offers reliable travel with timely pickup and comfortable vehicles. This route is popular among Navi Mumbai residents traveling to Pune for work or personal reasons."
},
{
name: "Ghansoli to Pune Cab",
description: "Ghansoli to Pune cab service provides convenient and safe travel between Navi Mumbai and Pune. Travelers can enjoy smooth highway journeys with experienced drivers."
},
{
name: "Mumbai to Pune Taxi Booking",
description: "Mumbai to Pune taxi booking service allows travelers to easily book cabs online with instant confirmation. Customers can choose from a wide range of vehicles for comfortable and reliable travel."
},
{
name: "Best Taxi Service in Mankhurd",
description: "Best taxi service in Mankhurd offers high-quality travel with clean vehicles, professional drivers, and timely pickups. This service is ideal for both local and outstation travel."
},
{
name: "Best Taxi Service in Mankhurd Contact Number",
description: "Taxi service contact number in Mankhurd helps customers quickly connect with reliable cab providers for booking taxis. Travelers can easily arrange rides for Pune and other destinations."
},
{
name: "Outstation Taxi Service in Mankhurd",
description: "Outstation taxi service in Mankhurd provides long-distance travel to Pune, Lonavala, Nashik, and more. Travelers can book comfortable vehicles with experienced drivers ensuring safe journeys."
},
{
name: "Outstation Taxi Service in Mankhurd Price",
description: "Outstation taxi service in Mankhurd price offers transparent fare details based on distance, vehicle type, and travel duration. Customers can plan their travel budget easily."
},
{
name: "Outstation Cab Service in Mumbai",
description: "Outstation cab service in Mumbai provides reliable long-distance travel across Maharashtra and beyond. Travelers can book comfortable vehicles for safe and convenient journeys."
},
{
name: "Mankhurd to Pune Cab",
description: "Mankhurd to Pune cab service offers dependable intercity transportation with comfortable vehicles and professional drivers ensuring safe travel."
},
{
name: "Mankhurd to Pune Cabs",
description: "Mankhurd to Pune cabs provide convenient travel options with flexible pickup and drop facilities for passengers."
},
{
name: "Mankhurd to Pune Cab Service",
description: "Mankhurd to Pune cab service ensures smooth and hassle-free travel with well-maintained vehicles and experienced drivers."
},
{
name: "Mankhurd to Pune Taxi Service",
description: "Mankhurd to Pune taxi service offers reliable travel with comfortable vehicles and professional drivers for a pleasant journey."
}
],

tableData: [
["Mankhurd to Pune Cab Service","Mankhurd to Pimpri Cab"],
["Mankhurd to Pune One Way Cab","Chembur to Pune Car Fare"],
["Belapur to Pune by Taxi","Belapur to Pune One Way Cab"],
["Belapur to Pimpri Chinchwad Cab","Belapur to Baner Cab Fare"],
["Seawoods to Pune Cab Fare","Seawoods to Pune Station Cab"],
["Sanpada to Pune Cab Service","Ghansoli to Pune Cab"],
["Mumbai to Pune Taxi Booking","Best Taxi Service in Mankhurd"],
["Best Taxi Service in Mankhurd Contact Number","Outstation Taxi Service in Mankhurd"],
["Outstation Taxi Service in Mankhurd Price","Outstation Cab Service in Mumbai"],
["Mankhurd to Pune Cab","Mankhurd to Pune Cabs"],
["Mankhurd to Pune Cab Service","Mankhurd to Pune Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Mankhurd to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Mankhurd to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mankhurd to Pune cab service operates 24 hours a day. Whether you need an early morning ride, business travel, airport transfer, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Mankhurd to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Mankhurd",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Mankhurd including Mankhurd East, nearby Chembur, Govandi, and Navi Mumbai locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mankhurd to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Mankhurd to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mankhurd to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Mankhurd from Pune?", answer: "The road distance between Mankhurd and Pune is approximately 140 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Mankhurd to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Mankhurd to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Mankhurd to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Mankhurd and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Mankhurd." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mankhurd to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Jadhav",
    feedback:
      "The Mankhurd to Pune journey was very comfortable and well-organized. The cab arrived on time, the ride was smooth, and the overall experience felt relaxed and hassle-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priya Kulkarni",
    feedback:
      "Traveling from Mankhurd to Pune was a pleasant experience. The vehicle was clean, the drive was steady, and everything was handled in a very professional manner.",
    rating: 5
  }
];






























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const mankhurdToPuneJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mankhurd to Pune Cab Service | Velocity Cabs",
  "description": "Book reliable Mankhurd to Pune cab with Velocity Cabs. Cars available: Innova, Sedan, Ertiga. One-way, round trips, and outstation taxi options at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mankhurd, Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Mankhurd to Pune Taxi",
    "One-way Cab Mankhurd to Pune",
    "Round Trip Cab Service",
    "Outstation Taxi",
    "AC Taxi Service"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mankhurd to Pune Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book reliable Mankhurd to Pune cab with Velocity Cabs. Innova, Sedan, Ertiga available for one-way, round trip, and outstation taxi options at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mankhurdToPuneJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mankhurdtopunecab;